import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const COMPONENT_ID = 'pricingTableCell'

export const PricingTableCellSchema = buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      availability: z.boolean(),
      customText: safeOptional(RichTextSchema),
    }),
  ),
})

export type PricingTableCell = z.infer<typeof PricingTableCellSchema>
